module.exports = __webpack_public_path__ + "static/media/whichThinnerRecommended.09ba157e.mp3";